import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { type DatadogUserIdentity, toDatadogRumUser } from "./datadog-user";

export function applyDatadogUserIdentity(identity: DatadogUserIdentity | null): void {
  if (!identity) {
    datadogRum.clearUser();
    datadogLogs.clearUser();
    datadogRum.removeGlobalContextProperty("org_id");
    datadogLogs.removeGlobalContextProperty("org_id");
    return;
  }

  const user = toDatadogRumUser(identity);
  datadogRum.setUser(user);
  datadogLogs.setUser(user);

  if (identity.orgId) {
    datadogRum.setGlobalContextProperty("org_id", identity.orgId);
    datadogLogs.setGlobalContextProperty("org_id", identity.orgId);
    return;
  }

  datadogRum.removeGlobalContextProperty("org_id");
  datadogLogs.removeGlobalContextProperty("org_id");
}
